<template>
    <div class="club-form">
        <nav class="top-navbar">
        <div class="title">
            <div class="title-inner">
                <span class="title-inner-name" v-i18n="'EVENT_UPDATE'" />
            </div>
        </div>
        <div class="icon-right">
            <router-link :to="'/events/' + event.id" class="bordered-icon btn-primary" v-if="!!event">
              <font-awesome-icon :icon="['fas','play']"/>
            </router-link>
            <router-link to="/events/calendar" class="bordered-icon btn-calendar" v-if="$hisport.options.platform.CONFIGURATION.ENABLE_EVENT_CALENDAR">
              <font-awesome-icon :icon="['fas','calendar']"/>
            </router-link>
            <help/>
        </div>
        </nav>
        <b-row v-if="!!event && !loading">
            <b-col cols="6">
                <event-form :event="event" @changed="changed" @changedForce="changedForce" :processing="processing"/>
            </b-col>

            <b-col cols="6" class="video" v-if="!!event && !!event.video && !!event.video.preview_url">
                <img :src="event.video.preview_url" style="width: 100%; padding: 15px;" controls/>
            </b-col>
            <b-col cols="6" class="box-info" v-else>
                <!-- <pre>{{JSON.stringify({
                    id_game_field:      game_field && game_field.id,
                    id_team_home:       team_home && team_home.id,
                    name_team_home:     team_home && team_home.name,
                    id_team_foreign:    team_foreign && team_foreign.id,
                    name_team_foreign:  team_foreign && team_foreign.name,
                    sport:              sport && sport.id,
                    category:           category && category.id,
                    season:             season && season.id,
                    visibility,
                    event_type,
                    match_type,
                    title
                }, null, 4)}}</pre> -->
                <img    :src="box_snapshots[game_field.id_hgbox]" class="snapshot"
                        v-if="game_field && game_field.id_hgbox && box_snapshots[game_field.id_hgbox]"/>
                <img    src="/images/event_default.jpg" v-else class="snapshot placeholder"/>

                <span v-if="game_field && game_field.id_hgbox && box_statuses[game_field.id_hgbox]" class="summary">
                    <span   v-if="box_statuses[game_field.id_hgbox].online == false" 
                            class="box-status offline">
                        <span class="img"><img src="/images/error.png" /></span>
                        <strong v-i18n="'BOX_OFFLINE'" />
                    </span>
                    <span   v-else-if="box_statuses[game_field.id_hgbox].status.status == 'NOT_RECORDING'"
                            class="box-status ready">
                        <span class="img"><img src="/images/info.png" /></span>
                        <strong v-i18n="'BOX_READY'" />
                    </span>
                    <span   class="box-status warning" v-else>
                        <span class="img"><img src="/images/warning.png" /></span>
                        <strong>
                            <span v-i18n="box_statuses[game_field.id_hgbox].status.status" :title="box_statuses[game_field.id_hgbox].status.recordingId"/>
                        </strong>
                    </span>
                </span>
                <!-- <font-awesome-icon :icon="['fas', 'futbol']" spin v-else-if="!!game_field"/> -->
            </b-col>
        </b-row>
    </div>
</template>
<script>
// import moment from "moment"
// const FORMAT_LOCALE = 'YYYY-MM-DDTHH:mm'
// const MIN_FUTURE_START = 5 * 60 * 1000;
// import eventShare from "../_components/event_share.vue";
import help from "../_components/help.vue";
import eventForm from "./event_form"
export default {
    title: "EVENT_UPDATE",
    components:{
        eventForm,
        help
    },
    async mounted(){
        await this.init(this.password)
        this.$store.dispatch("setLoading", false);
    },
    beforeDestroy(){
        clearInterval(this.schedInterval)
    },
    data(){
        return{
            loading: false,
            event: null,
            box_snapshots: {},
            box_statuses: {},
            game_field: null,
            processing: false
        }
    },
    methods:{
        changedForce: function(args){
            console.log("changed", args)
            this.game_field = args;
            this.getSnapshot(args.id_hgbox,true);
            this.getHiBoxInfo(args.id_hgbox,true);
        },
        changed: function(args){
            console.log("changed", args)
            this.game_field = args;
            this.getSnapshot(args.id_hgbox);
            this.getHiBoxInfo(args.id_hgbox);
        },
        //#region "HiBox"
        getSnapshot(id_box, force){
            if(!force && this.box_snapshots[id_box])
                return this.snapshot = this.box_snapshots[id_box];
            this.processing = true;
            var self = this;
            this.$hisport.datacontext.hiBox.camera.getSnapshot(id_box)
            .then(function(response){
                const url = window.URL.createObjectURL(new Blob([response]));
                self.$set(self.box_snapshots, id_box, url);
                self.processing = false;
            })
            .catch(function(){
                self.processing = false;
            })
        },
        getHiBoxInfo(id_box){
            var self = this;
            this.$hisport.datacontext.hiBox.recording.getStatus(id_box)
            .then(function(response){
                self.$set(self.box_statuses, id_box, {
                    online: true,
                    status: response
                });
            })
            .catch(function(error){
                self.$set(self.box_statuses, id_box, {
                    online: false,
                    error: error && error.message
                });
            })
        },
        //#endregion
        init(password){
            this.loading = true;
            var self = this;
            this.$hisport.datacontext.event.getById(this.$route.params.id, {
                include: [
                    "event.video", 
                    "event.teams", 
                    // "event.users", 
                    "event.game_field", 
                    // "event.tags", 
                    // "tag.tag_type",
                    // "game_field.structure",
                    "team.club",
                    // "club.users"
                ],
                password: password,
                params: [{name: "id_user", value: this.$hisport.getUserId()}]
            })
            .then(function(event){
                var enabled = false;
                if(event.game_field && event.game_field){
                    enabled = self.$hisport.permissions.updateStructure(event.game_field.id_structure)
                }
                if(!enabled && event.team_home && event.team_home.club){
                    enabled = self.$hisport.permissions.updateClub(event.team_home.club.id)
                }
                if(!enabled) {
                    alert(self.$hisport.i18n('EDIT_EVENT_USER_NOT_AUTHORIZED'))
                    return self.$router.replace({ path: "/" })
                }
                self.event = event;
                
                self.loading = false;
                self.$store.dispatch("setLoading", false);
                })
            .catch(function(error){
                console.error(error)
                self.loading = false;
                self.$store.dispatch("setLoading", false);
            })
        }
    }
}
</script>
<style scoped>
.buttons .btn{
    margin-top: 20px;
}
.box-info{
    position:       relative; 
    padding:        0px; 
    color:          #FFFFFF; 
    font-weight:    bold;
    margin-top:     13px; 
    /* display:        flex; */
}
.box-info .snapshot{
    left:   0; 
    width:  calc( 100% - 40px ); 
    height:auto;
    /* flex:   1 1 auto; */
    margin-right:40px;
}
    .box-info .snapshot.placeholder{
        opacity:0.1; 
        filter:grayscale(1);
    }

.box-info .summary{
    position:       absolute;
    text-align:     center; 
    left:           0; 
    width:          calc( 100% - 40px );
    /* flex:           1 1 auto;   */
    height:         100%;
    top:            0
}
.box-info .box-status{
    position:       absolute;
    display:        flex; 
    flex-direction: column;  
    /* height:         100%; */
    width:          100%;
    top:            0;
}
.box-info .box-status .img{
    width:          100%;
    text-align:     center;
    margin-bottom:  20px;
    margin-top:     10%;
    display:        inline;
}
.box-info .box-status .img img{
    width:          25%;
    filter:         drop-shadow(0px 0px 15px rgba(0,0,0,.1));
}
.box-info .box-status strong{
    position:       absolute; 
    /* bottom:         0;  */
    width:          100%; 
    background:#333333;
}
    .box-info .box-status.ready strong{
        background: var(--green);
    }
    .box-info .box-status.offline strong{
        background: var(--hg-red);
    }
    .box-info .box-status.warning strong{
        background: var(--hg-warn);
    }

button[disabled]       {                background: var(--hg-red-alpha)!important;                                    }
.v-select.hg-select img{                margin-right:10px;                                                            }
.v-select.hg-select img+span+svg{       position:absolute; right:10px; color: var(--hg-warn);                         }
</style>